import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { anchor: String }

  connect() {
    if (this.hasAnchorValue) {
      // Small delay to ensure the DOM is fully updated
      setTimeout(() => this.scrollToAnchor(), 50)
    }
  }

  scrollToAnchor() {
    const element = document.getElementById(this.anchorValue)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
